import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconOrganization$1 = /*@__PURE__*/ proxyCustomElement(class WppIconOrganization extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-organization", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.0086 1.90002C8.34538 1.90002 6.99707 3.24834 6.99707 4.91156C6.99707 6.31592 7.95834 7.49577 9.25879 7.82901V9.25002H7.13061C5.65663 9.25002 4.46173 10.4449 4.46173 11.9189V12.1711C3.16137 12.5044 2.2002 13.6842 2.2002 15.0885C2.2002 16.7517 3.54851 18.1 5.21173 18.1C6.87496 18.1 8.22327 16.7517 8.22327 15.0885C8.22327 13.6842 7.26209 12.5044 5.96173 12.1711V11.9189C5.96173 11.2733 6.48506 10.75 7.13061 10.75H12.8877C13.5333 10.75 14.0566 11.2733 14.0566 11.9189V12.1711C12.7563 12.5044 11.7951 13.6842 11.7951 15.0885C11.7951 16.7517 13.1434 18.1 14.8066 18.1C16.4699 18.1 17.8182 16.7517 17.8182 15.0885C17.8182 13.6842 16.857 12.5044 15.5566 12.1711V11.9189C15.5566 10.4449 14.3617 9.25002 12.8877 9.25002H10.7588V7.82892C12.0591 7.49555 13.0201 6.31579 13.0201 4.91156C13.0201 3.24834 11.6718 1.90002 10.0086 1.90002ZM8.49707 4.91156C8.49707 4.07676 9.17381 3.40002 10.0086 3.40002C10.8434 3.40002 11.5201 4.07676 11.5201 4.91156C11.5201 5.74636 10.8434 6.4231 10.0086 6.4231C9.17381 6.4231 8.49707 5.74636 8.49707 4.91156ZM3.7002 15.0885C3.7002 14.2537 4.37693 13.5769 5.21173 13.5769C6.04653 13.5769 6.72327 14.2537 6.72327 15.0885C6.72327 15.9233 6.04653 16.6 5.21173 16.6C4.37693 16.6 3.7002 15.9233 3.7002 15.0885ZM13.2951 15.0885C13.2951 14.2537 13.9718 13.5769 14.8066 13.5769C15.6414 13.5769 16.3182 14.2537 16.3182 15.0885C16.3182 15.9233 15.6414 16.6 14.8066 16.6C13.9718 16.6 13.2951 15.9233 13.2951 15.0885Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-organization-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-organization", "wpp-icon-organization-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-organization-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-organization-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconOrganization$1);
      }
      break;
  } });
}

const WppIconOrganization = WppIconOrganization$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconOrganization, defineCustomElement };
